// v2.6.4 — shared poller for staff-side widgets.
//
// Morning-peak RCA (Oct 2026): ~450 phones opened the app at 08:30–09:15 and
// each one polled 5–6 endpoints every 5–15 s (≈45 requests/min/device →
// 300+ req/s fleet-wide), saturating the DB and triggering retry storms.
// Every poller now: (a) skips ticks while the app is backgrounded,
// (b) applies ±20 % jitter so devices don't fire in lockstep,
// (c) refreshes immediately when the app returns to the foreground.
export function startPoll(fn, intervalMs) {
  let stopped = false;
  let timer = null;

  const hidden = () => typeof document !== 'undefined' && document.visibilityState === 'hidden';
  const run = () => { if (!stopped && !hidden()) { try { const p = fn(); if (p && p.catch) p.catch(() => {}); } catch {} } };
  const schedule = () => {
    if (stopped) return;
    const jitter = intervalMs * 0.2 * (Math.random() * 2 - 1);
    timer = setTimeout(() => { run(); schedule(); }, Math.max(1000, intervalMs + jitter));
  };
  const onVisible = () => { if (!hidden()) run(); };

  run();
  schedule();
  if (typeof document !== 'undefined') document.addEventListener('visibilitychange', onVisible);

  return () => {
    stopped = true;
    if (timer) clearTimeout(timer);
    if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', onVisible);
  };
}
